import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, Link } from "react-router-dom";


const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

 // 🧭 Smart Redirect Logic for CashKaro + Ecommerce
let redirectTo = "/home"; // default CashKaro page

if (location.state?.from) {
  // if coming from ecommerce section (shop, product, checkout, cart)
  if (
    location.state.from.includes("/shop") ||
    location.state.from.includes("/product") ||
    location.state.from.includes("/checkout") ||
    location.state.from.includes("/cart")
  ) {
    redirectTo = location.state.from;
  } else {
    redirectTo = "/home"; // for normal cashkaro pages
  }
} else if (window.location.pathname.includes("/shop")) {
  // if user opened login directly from ecommerce side
  redirectTo = "/shop";
}



  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post("https://hrgf.salepatner.com/api/login/", formData);

    // ✅ Correct token saving (this line was the issue)
    localStorage.setItem("token", res.data.tokens.access);
    localStorage.setItem("access_token", res.data.tokens.access);
    localStorage.setItem("refresh_token", res.data.tokens.refresh);
    localStorage.setItem("username", res.data.username);

    console.log("✅ Login successful! Token saved:", res.data.tokens.access);

    // 🔁 Redirect based on where login started
    navigate(redirectTo, { replace: true });
    window.location.reload(); // 👈 add this line
  } catch (err) {
    console.error("Login error:", err);
    setError("Invalid username or password. Please try again.");
  }
};



  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 relative">
      {/* Glass Background Overlay */}
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>

      {/* Login Card */}
      <div className="relative z-10 flex flex-col md:flex-row w-11/12 max-w-5xl bg-white shadow-2xl rounded-3xl overflow-hidden border border-gray-200">

        {/* LEFT SIDE - Info Panel */}
        <div className="hidden md:flex flex-col justify-center items-center w-1/2 bg-gradient-to-br from-gray-800 via-gray-700 to-gray-900 text-white p-10">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1087/1087840.png"
            alt="Login Illustration"
            className="w-36 mb-6 opacity-90"
          />
          <h2 className="text-3xl font-bold mb-3">Welcome Back to HRGF</h2>
          <p className="text-base opacity-90 text-center leading-relaxed mb-6">
           
          </p>
          <Link
            to="/signup"
            className="border border-white px-8 py-2 rounded-full text-white hover:bg-white hover:text-gray-900 transition font-semibold"
          >
            Create Account
          </Link>
        </div>

        {/* RIGHT SIDE - Login Form */}
        <div className="w-full md:w-1/2 bg-white p-10 md:p-14 flex flex-col justify-center items-center">
          <h2 className="text-3xl font-extrabold text-gray-800 mb-2">
            Sign in to DigiKaro
          </h2>
          <p className="text-gray-500 mb-8">Access your cashback dashboard</p>

          <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-5">
            <div>
              <input
                type="text"
                placeholder="Username"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-500"
                value={formData.username}
                onChange={(e) =>
                  setFormData({ ...formData, username: e.target.value })
                }
              />
            </div>

            <div>
              <input
                type="password"
                placeholder="Password"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-500"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
            </div>

            {error && <p className="text-red-500 text-sm">{error}</p>}

            <button
              type="submit"
              className="w-full bg-gray-800 text-white py-3 rounded-lg font-semibold hover:bg-gray-900 transition shadow-md"
            >
              Login
            </button>
          </form>

          {/* Divider */}
          <div className="flex items-center w-full max-w-sm my-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <p className="text-gray-400 text-sm px-3">or</p>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>

          {/* Google Login */}
          <button className="w-full max-w-sm border border-gray-300 rounded-lg py-3 flex items-center justify-center gap-2 hover:bg-gray-50 transition">
            <img
              src="https://www.svgrepo.com/show/355037/google.svg"
              alt="Google"
              className="w-5 h-5"
            />
            <span className="text-gray-700 font-medium">
              Continue with Google
            </span>
          </button>

          {/* Signup Redirect */}
          <p className="text-gray-500 text-sm mt-6">
            Don’t have an account?{" "}
            <Link
              to="/signup"
              className="text-gray-800 font-semibold hover:underline"
            >
              Sign up here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
